<template>
    <div>
        <div class="order-tmp-caption" style="font-size: 15px;color: #1a1a1a;font-weight: 600;text-align: center;padding: 15px 0;">巡检凭单</div>
        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size: 12px;">
            <thead class="head">
            <tr class="row">
                <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                    <div>序号</div>
                </th>
                <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                    <div>分组</div>
                </th>
                <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                    <div>项目（内容）</div>
                </th>
                <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                    <div>基本要求</div>
                </th>
                <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                    <div>结果</div>
                </th>
                <th style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;color: #1a1a1a;font-weight: 600;">
                    <div>结果说明</div>
                </th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="checkItem in checkWorkVoucher.detailItems">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div>{{checkItem.seqNo}}</div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div>{{checkItem.group}}</div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div>{{checkItem.content}}</div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div>{{checkItem.demand}}</div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div>{{checkItem.markChar == '✓' ? '√' : checkItem.markChar}}</div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div>{{checkItem.remark}}</div>
                </td>
            </tr>
            <tr class="row">
                <td colspan="6" style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="">说明：结果正常是在对应的结果栏中打√</div>
                </td>
            </tr>
            </tbody>
        </table>
        <table class="simple-tbl" style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size: 12px;">
            <tbody class="body">
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item clearfix">
                        <div class="label" style="width: 160px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            {{checkWorkVoucher.svcCmntLabel}}
                        </div>
                        <div class="value" style="float: left; width: calc(100% - 160px); width: -webkit-calc(100% - 160px);white-space: normal; word-break: break-all;">
                            {{checkWorkVoucher.svcCmntValue}}
                        </div>
                    </div>
                    <div class="sign-name" style="height: 160px;text-align: center;">
                        <img style="height: 160px;" :src=" checkWorkVoucher.svcSigImgUrl"/>
                    </div>
                    <div class="info-item clearfix">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            {{checkWorkVoucher.svcDateLabel}}
                        </div>
                        <div class="value align-right" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;" v-if="checkWorkVoucher.svcDateValue != null">
                            <span>{{new Date(checkWorkVoucher.svcDateValue).format("yyyy年MM月dd日")}}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item clearfix">
                        <div class="label" style="width: 160px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            {{checkWorkVoucher.selfCmntLabel}}

                        </div>
                        <div class="value" style="float: left; width: calc(100% - 160px); width: -webkit-calc(100% - 160px);white-space: normal; word-break: break-all;">
                            {{checkWorkVoucher.selfCmntValue}}

                        </div>
                    </div>
                    <div class="sign-name" style="height: 160px;text-align: center;">
                        <img style="height: 160px;" :src=" checkWorkVoucher.selfSigImgUuid"/>
                    </div>
                    <div class="info-item clearfix">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            {{checkWorkVoucher.selfStaffLabel}}

                        </div>
                        <div class="value align-right" style="float: left; width: calc(100% - 86px); width: -webkit-calc(100% - 86px);white-space: normal; word-break: break-all;" v-if="checkWorkVoucher.selfDateValue != null">
                            <span>{{new Date(checkWorkVoucher.selfDateValue).format("yyyy年MM月dd日")}}</span>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    //
    import servcDelivApi from '../../api/servcDeliv'
    //
    export default {
        name: 'swb-servc-work-check-voucher-voucher-list',
        desc: '工单补充项目',
        props: ["id"],
        data: function () {
            return {
                checkWorkVoucher: {},
                groupFlag: false,
                remarkFlag: false,
            }
        },
        created: function () {
            this.getDevcMaintVoucher();
        },
        methods: {
            getDevcMaintVoucher: function () {
                let self = this;
                let postData = {
                    refSrcId: self.id,
                };
                servcDelivApi.getCheckWorkVoucherByRefSrcId(postData, function (result) {
                    if(result.type == "info") {
                        let checkWorkVoucher = result.data;

                        self.checkWorkVoucher = checkWorkVoucher;
                    }
                })
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/workVoucher/CheckWorkVoucherPdf.vue